import React from 'react'
import { Link } from 'react-router-dom';
import { Button } from '../Button/Button';

export const Anexos = (props) => {
   
    return (
        <div className="resultadosContainer">
            <div className="resultadosContainer--mainDiv">
                <div className="title">
                    <div className="title--container">
                        <Link to={'/informacion_general'}>Información general</Link>
                    </div>
                </div>
                <div className="subtitle">
                    <div className="subtitle--container">
                        <p>Anexos por modelo/plan</p>
                    </div>
                </div>
            </div>
            <div className="resultadosContainer--secondDiv">
                <div className="innerDiv">
                    <Button className="btn-acto" pdf='/pdf/informacion-general/anexos/anexos_compass.pdf' img='/images/icons/download.svg' text='Anexos plan compass'  />
                    <Button className="btn-acto" pdf='/pdf/informacion-general/anexos/anexos_renegade_sport.pdf' img='/images/icons/download.svg' text='Anexos plan renegade sport' />
                    <Button className="btn-acto" pdf='/pdf/informacion-general/anexos/anexos_renegade_longitude.pdf' img='/images/icons/download.svg' text='Anexos plan renegade longitude' />
                </div>
            </div>
        </div>
    )
}
